import { MuiThemeProvider, createTheme } from "@material-ui/core/styles";
import { Provider, connect } from "react-redux";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { createStore } from "redux";
import "./GlobalStyle.css";
import Demo from "./components/Demo";
import Frontpage from "./components/Frontpage.js";
import Navigator from "./components/navigator/Navigator.js";
import CookiePolicy from "./components/playlist/CookiePolicy.jsx";
import CreatePlaylist from "./components/playlist/CreatePlaylist";
import Playlist from "./components/playlist/Playlist";
import PrivacyPolicy from "./components/playlist/PrivacyPolicy.js";
import TermsOfUse from "./components/playlist/TermsOfUse.jsx";
import Documentation from "./documentation/Documentation.js";
import rootReducer from "./reducers";

const theme = createTheme({
    palette: {
        primary: {
            main: "#96e8a6"
        },
        menu: {
            main: "#e0e0e0"
        }
    },
    overrides: {
        MuiTableRow: {
            root: {
                "&:last-child td": {
                    borderBottom: 0
                }
            }
        }
    }
});

const store = createStore(rootReducer);

const App = connect(state => state)(props => {
    return (
        <MuiThemeProvider theme={theme}>
            <BrowserRouter>
                <Switch>
                    <Route
                        render={props => (
                            <>
                                <Switch>
                                    <Route path="/" exact component={Frontpage} />
                                    <Route path="/Demo" exact component={Demo} />
                                    <Route path="/documentation" component={Documentation} />
                                    <Route path="/CreatePlaylist" exact component={CreatePlaylist} />
                                    <Route path="/Playlist" exact component={Playlist} />
                                    <Route path="/PrivacyPolicy" exact component={PrivacyPolicy} />
                                    <Route path="/TermsOfUse" exact component={TermsOfUse} />
                                    <Route path="/CookiePolicy" exact component={CookiePolicy} />
                                    <Route path="/" component={Navigator} />
                                </Switch>
                            </>
                        )}
                    />
                </Switch>
            </BrowserRouter>
        </MuiThemeProvider>
    );
});

export default props => (
    <Provider store={store}>
        <App />
    </Provider>
);
